
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 8h-4V4.79C15 3.25 13.75 2 12.21 2c-1.15 0-2.16.69-2.57 1.71L6.81 10h-3.8c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h4c.35 0 .65-.19.83-.47l.31.15c.41.21.88.32 1.34.32h7.89c1.43 0 2.66-1.01 2.94-2.41L22 11.2c.01-.06.02-.13.02-.2 0-1.65-1.34-3-3-3H19zM6 20H4v-8h2v8zm12.34-.8c-.09.46-.5.8-.98.8H9.47c-.15 0-.31-.04-.45-.11l-.47-.24a.988.988 0 01-.55-.89v-6.55l3.48-7.72c.12-.3.41-.5.73-.5.44 0 .79.35.79.79v4.21c0 .55.45 1 1 1h5c.52 0 .95.4.99.92l-1.66 8.28.01.01z"}})])
          )
        }
      }
    